import Vue from 'vue'
import common from "@/services/common"

export default {
  async list() {
    console.log("apiapproval - list")
    return common.execute("GET", "/api/appconfig/v1/approvals")
      .then(result => result.approvals)
  },
  async create(diff, fileID, overrideFileID) {
    console.log("apiapproval - create(", fileID, overrideFileID, diff, ")")
    const body = {
      createdBy: 'AppConfig User',
      configFileID: fileID,
      overrideFileID: overrideFileID,
      diff: diff,
    }
    return common.execute("POST", "/api/appconfig/v1/approvals", body).then(() => {
      Vue.prototype.$alert.success(`Approval submitted successfully`)
    })
  },
}